"use strict";

var visit = require("unist-util-visit");

var frontmatter = require("front-matter");

var attacher = function attacher() {
  var transformer = function transformer(tree, _file) {
    visit(tree, 'code', function (node) {
      var fm = frontmatter(node.value);
      node.frontmatter = fm.attributes;
      node.value = fm.body;
    });
    return tree;
  };

  return transformer;
};

module.exports = attacher;